// Component logic that is shared by all the SVG Field Components.  Keeping it all in one spot and using Mixins to share.  
// Every <svg> element must have a "ref='svg'" added to it, and any position element needs "player-position" as the first classname.
export default {
    props: {
        positions: {
            type: Array
        }
    },
    mounted() {
        // Reference this
        let vm = this;
        // Get all the positions that are available in the inline SVG
        const svgPositions = this.$refs.svg.querySelectorAll('.player-position');
        // For each position, check if the player plays it and if so, add the active class
        svgPositions.forEach( position => {
            let isActive = false;

            for(let i = 0; i < position.classList.length; i++) {
                if(vm.playsPosition.includes(position.classList[i])) {
                    isActive = true;
                    break;
                }
            }

            isActive ? position.classList.add('active') : '';
        })
    },
    computed: {
        // Transform the position prop array strings that have spaces to kebab-case to match the class names on the SVG (if there's no space in the position name it'll remain the same)
        playsPosition() {
            // console.log(this.positions)
            return this.positions.map(position => position.toLowerCase().replace(/\s\/\s|\s/g, '-') )
            // return this.positions.map(position => position.toLowerCase().split(/( | \/ )/).join('-'))
        }
    }
}